import { Pipe, PipeTransform } from '@angular/core';
import { Message } from '../models/tracer.model';

// Canonical order for the message-tab buttons. Whatever the backend ships
// (created_at asc, varies by which capture path landed first), the UI
// must always render the request half on the left and the response half
// on the right.
//
//   json-api  → input → output
//   requester → provider_request → provider_response
//
// Anything not in this list keeps its incoming order, appended after
// the known names. Lookup is O(1) — names are static.
const MESSAGE_ORDER: Record<string, number> = {
  input: 0,
  provider_request: 0,
  output: 1,
  provider_response: 1,
};

const FALLBACK_RANK = Number.MAX_SAFE_INTEGER;

@Pipe({
  name: 'orderMessages',
})
export class OrderMessagesPipe implements PipeTransform {
  transform(messages: Message[] | null | undefined): Message[] {
    if (!messages?.length) return [];
    return [...messages].sort(
      (a, b) => (MESSAGE_ORDER[a.name] ?? FALLBACK_RANK) - (MESSAGE_ORDER[b.name] ?? FALLBACK_RANK)
    );
  }
}
